import { Component, OnInit, forwardRef, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { StatusService } from '../../services/status.service';


@Component({
    selector: 'dhs-rating',
    templateUrl: './rating.component.html',
    styleUrls: ['./rating.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RatingComponent),
            multi: true
        }
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RatingComponent implements OnInit, ControlValueAccessor {
  @Input() id: any;
  @Input('value') _value:any=false;
  @Input() className;
  @Input() req_stars: number;
  @Output() valueChange = new EventEmitter<any>();
  disable: boolean = false;
  options: any = [];
  propagateChange = (_: any) => { };
  onTouched: any = () => { };
  checkboxData: Array<any> = [];

  constructor(private statusService: StatusService) {
    
  }
  ngOnInit() {
    
    for (let i = 0; i < this.req_stars; i++) {
      this.options.push({ "value": i + 1 })
    }
    console.log('options are ==>>', this.options);
    this.setvalueForUpdate(this.value);
    let status = this.statusService.getStatus();
    this.disable = false;
    if(status == 'collected' || status == 'reviewCompleted' || status == 'rejectFeedback') {
      this.disable = true;
    } else {
      this.disable = false;
    }
  }

  get value(): any {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.propagateChange(val);
    this.onTouched();
  }

  writeValue(value) {
    this.setvalueForUpdate(value);
  }
  setvalueForUpdate(value){
    if (value) {
      this.value = value;
      for (let i = 0; i < this.value; i++) {
        this.options[i]['selected'] = true;
      }
    } else {
      this.value = false;
    }
  }
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  getCurrentItems(index) {
    for (let i = 0; i < this.options.length; i++) {
      if (this.options[i]['selected'] != undefined)
        this.options[i]['selected'] = false;
    }
    for (let i = 0; i <= index; i++) {
      this.options[i]['selected'] = true;
    }
    this.value = index + 1;
    this.valueChange.emit(this.value)
  }
}
